/* <body> itself was never claimed by anything: core webshop paints it a
 * hardcoded literal (webshop_cart.scss's body.product-page { background:
 * var(--body-bg-color) } → --gray-50, near-white), and no RFHQ script or
 * CSS rule ever touched it. Invisible on pages built from edge-to-edge
 * Sections (Home, ...) since their own full-width backgrounds fully cover
 * it - but on PDP/Cart, whose content sits inset in a Bootstrap
 * `.container`, that literal shows straight through as a white header,
 * breadcrumb row, and margins around the (correctly) dark-themed content
 * boxes. Found live: PDP screenshot under the Dark preset.
 *
 * Fix reuses 100% existing infrastructure - claim <body> as
 * data-rfhq-owned same as every other page in this codebase, and the
 * already-existing generic `[data-rfhq-theme] { background: var(--rfhq-
 * section-bg); color: var(--rfhq-section-text); }` rule (rfhq_templates.css)
 * does the rest. No new CSS. Being the outermost possible element, this
 * can never win over an explicit Section-level theme override further
 * down - rfhqApplyOwnedThemeFallback's own closest() guard already
 * handles that for every other owned surface.
 */

frappe.ready(function () {
	document.body.setAttribute('data-rfhq-owned', '1');
	if (window.rfhqApplyOwnedThemeFallback) window.rfhqApplyOwnedThemeFallback(document.body);
});
